import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

function slideEnterAnimationConfig(n, duration, stepDelay) {
    let slideDirection;
    if (n > 9) {
        n = n - 9;
        slideDirection = "slideUp";
    } else {
        slideDirection = "slideDown";
    }

    let slideDelay = (Math.abs(5 - n) % 5) * stepDelay;

    return `${duration}s ease ${slideDelay}s ${slideDirection} both`;
}

function exitAnimationConfig(n, duration, stepDelay) {
    if (n > 9) {
        n = n - 9;
    }

    let slideDelay = n * stepDelay;

    return `${duration}s ease-out ${slideDelay}s flip-out forwards, ${duration}s ease ${slideDelay}s fade-out forwards`;
}

export function ImageTile(props) {
    const smallImage = [3, 4, 5, 12, 13, 14];
    let fullName = props.artistInfo.name;
    let splitSpace = fullName.lastIndexOf(" ");
    let names =
        props.mobile ? [fullName] :
        splitSpace !== -1
            ? [fullName.slice(0, splitSpace), fullName.slice(splitSpace + 1)]
            : [fullName];

    let navigate = useNavigate();

    return (
        <Box
            role="link"
            aria-label={`${fullName} image tile. Clicking navigates to ${fullName} profile page.`}
            style={{
                textDecoration: "none",
                animation: props.mobile ? "" : props.exitPage
                    ? exitAnimationConfig(
                          props.artistInfo.imageSortOrder,
                          props.exitAnimationDuration,
                          props.exitAnimationDelay
                      )
                    : slideEnterAnimationConfig(
                          props.artistInfo.imageSortOrder,
                          1.5,
                          0.3
                      ),
            }}
            onClick={() => {
                props.setExitPage(true);
                if (props.setSliderOpen) props.setSliderOpen(false);
                setTimeout(() => {
                    navigate(`/profile/${props.artist}`);
                }, props.exitDelay);
            }}
            sx={{
                height: props.mobile ? "auto" : smallImage.includes(props.index) ? "31.90vh" : "38.84vh",
                minHeight: props.mobile ? "" : smallImage.includes(props.index) ? "168px" : "205px",
                width: props.mobile ? "100%" : "auto",
                background: `url(${props.mobile ? props.artistInfo.mobileImage : props.artistInfo.mtaImage})no-repeat`,
                backgroundSize: "contain",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center",
                alignSelf: props.mobile ? "" : props.index < 9 ? "start" : "end",
                aspectRatio: props.mobile ? "189/248" : smallImage.includes(props.index) ? "27/53" :"351/839.24",
                gridRow: props.mobile ? "" : props.index < 9 ? "1" : "3"
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    padding: "0 1px 10px 1px",
                    backgroundImage:
                        "linear-gradient(to bottom, rgb(34,34,34,0), rgb(34,34,34,1))",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                }}
            >
                {names.map((name) => {
                    return (
                        <Typography
                            key={name}
                            sx={{
                                fontFamily: "GT Eesti Display Bold",
                                fontSize: props.mobile ? 
                                (name === "Kenneth Hordge (FINGERCREATIONS)" ? "10.5pt" : "11pt") : "max(8px, 1.482vh)",
                                lineHeight: props.mobile ? "13pt" : "max(10px, 1.713vh)",
                                letterSpacing: props.mobile ? "0.36pt" : "0.64px",
                                
                                color: "text.darker",
                                textAlign: "center",
                            }}
                        >
                            {name}
                        </Typography>
                    );
                })}
            </Box>
        </Box>
    );
}
